import taskTemplatesHeaderButtonsUrl from './taskTemplatesHeaderButtons.html';

class TaskTemplatesHeaderButtonsCtrl {
  constructor(ShiftTasksService, TaskTemplatesService, $state, $scope) {
    'ngInject';

    Object.assign(this, { ShiftTasksService, TaskTemplatesService, $state, $scope });

    this.query = this.TaskTemplatesService.query;
  }

  $onInit() {
    this.typingWatcher = this.$scope.$watch('ctrl.query', (query, prevQuery) => {
      if (query !== prevQuery) {
        this.searchWithinTemplates(query);
      }
    });
  }

  $onDestroy() {
    this.TaskTemplatesService.resetFilters();
    this.typingWatcher?.();
  }

  get isFeatureAvailable() {
    return this.ShiftTasksService.isFeatureEnabled;
  }

  createTemplate() {
    this.$state.go('shiftTasks.templates.add');
  }

  searchWithinTemplates(searchText) {
    this.TaskTemplatesService.search(searchText);
  }
}

export default {
  templateUrl: taskTemplatesHeaderButtonsUrl,
  controller: TaskTemplatesHeaderButtonsCtrl,
  controllerAs: 'ctrl',
};
